import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "@store";
import { jsx as _jsx } from "react/jsx-runtime";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/ _jsx(React.StrictMode, { children: /*#__PURE__*/ _jsx(Provider, { store: store, children: /*#__PURE__*/ _jsx(App, {}) }) }));
reportWebVitals();
